// extracted by mini-css-extract-plugin
export default {"image":"styles_image__Ex1MU","padding":"styles_padding__ko9iP"};